// src/pages/Frage.jsx
// Rueckfrage mit klar beschrifteten Knoepfen (Pruefung 20.09.2026).
//
// window.confirm kennt nur "OK" und "Abbrechen". An drei Stellen tat "Abbrechen"
// aber etwas (z. B. "Abbrechen = trotzdem eine NEUE anlegen") - wer einfach nichts
// tun wollte, legte ein zweites Protokoll an. Hier steht auf jedem Knopf, was er
// tut, und "Abbrechen" macht IMMER nichts.
//
//   const wahl = await frage({ titel, text, knoepfe: [{ wert, text, art }] });
//   wahl = wert des Knopfs, oder null bei Abbrechen.
// art: 'haupt' (gruen), 'gefahr' (rot), sonst schlicht.

import { createRoot } from 'react-dom/client';
import { C } from './formui';
import { t } from '../lib/sprache';

function FrageFenster({ titel, text, knoepfe, abbrechenText, fertig }) {
  const farbe = (art) => (art === 'haupt' ? { background: C.green, color: C.white, border: 'none' }
    : art === 'gefahr' ? { background: C.white, color: C.red, border: '1.5px solid ' + C.red }
      : { background: C.white, color: C.navy, border: '1.5px solid ' + C.gray300 });
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', zIndex: 500,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12,
                  fontFamily: "system-ui,-apple-system,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif" }}
         onClick={() => fertig(null)}>
      <div onClick={e => e.stopPropagation()}
           style={{ background: C.white, borderRadius: 12, padding: 18, width: '100%', maxWidth: 460 }}>
        {titel && <div style={{ fontSize: 17, fontWeight: 800, color: C.navy, marginBottom: 6 }}>{titel}</div>}
        {text && <div style={{ fontSize: 15, color: C.gray700, lineHeight: 1.45, whiteSpace: 'pre-line' }}>{text}</div>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
          {knoepfe.map(k => (
            <button key={k.wert} type="button" onClick={() => fertig(k.wert)}
              style={{ minHeight: 48, padding: '10px 16px', borderRadius: 9, fontSize: 15, fontWeight: 800,
                       cursor: 'pointer', fontFamily: 'inherit', ...farbe(k.art) }}>
              {k.text}
            </button>
          ))}
          <button type="button" onClick={() => fertig(null)}
            style={{ minHeight: 44, padding: '8px 16px', borderRadius: 9, fontSize: 15, fontWeight: 700,
                     cursor: 'pointer', fontFamily: 'inherit', background: C.gray100, color: C.gray700, border: 'none' }}>
            {abbrechenText || t('Abbrechen – nichts tun')}
          </button>
        </div>
      </div>
    </div>
  );
}

export function frage({ titel, text, knoepfe = [], abbrechenText } = {}) {
  return new Promise((ergebnis) => {
    const huelle = document.createElement('div');
    document.body.appendChild(huelle);
    const wurzel = createRoot(huelle);
    const fertig = (wert) => {
      wurzel.unmount();
      huelle.remove();
      ergebnis(wert);
    };
    wurzel.render(<FrageFenster titel={titel} text={text} knoepfe={knoepfe} abbrechenText={abbrechenText} fertig={fertig}/>);
  });
}
